import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/system";
import React from "react";
import { tokens } from "../../Theme/theme";
import '../../assets/fonts/fonts.css'

export const Header = ({ title, titleFontSize = "24px", subtitle, tag = "", imgInc = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const isMobileScreen = useMediaQuery('(max-width:500px)');
  const isTabScreen = useMediaQuery('(max-width:1200px)')

  return (
    <Box mb={imgInc ? "0px" : "30px"}>

      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: "wrap"
      }}>
        <Typography
          fontSize={titleFontSize}
          gutterBottom={false}
          color={colors.grey[100]}
          fontFamily={"poppins-reg"}
          sx={{ m: "0 10px 0px 0px" }}
        >
          {title}
        </Typography>
        {
          tag && (
            <Typography fontFamily={'poppins-reg'} color={"#943bff"}
              style={{
                background: "#943bff20", borderRadius: "5px", border: "1px solid #943bff50", paddingBlock: "1px",
                paddingInline: "6px", fontSize: "12px", 
              }}
            >
              #{tag}
            </Typography>
          )
        }

      </Box>

      <Typography style={{ }} variant={(isMobileScreen || isTabScreen) ? "h6" : "h5"} fontFamily={'poppins-reg'} color={colors.grey[500]}>
        {subtitle}
      </Typography>
    </Box>
  );
};
